module.exports = __webpack_public_path__ + "static/media/kia-icon-noneOption.047fa47f.svg";